import getters from './getters.js'
import actions from './actions.js'
import mutations from './mutations.js'

const state = {
  zonaWaktu: 'Asia/Jakarta',
  waktuSaatIni: null,
}

export default {
  state,
  getters,
  actions,
  mutations
}
